export default "__VITE_ASSET__Kxj_CzYp__"